import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { showPortalInviteFeedback } from "../../../utils/portalInviteFeedback";
import s from "./clientApp.module.css";
import { Button, Field, Input, useToast } from "../../ui";

function portalStatusLabel(athlete) {
  if (athlete.portal_activated) return "Вход активирован";
  if (athlete.portal_login_email) return "Ожидает активации";
  return "Email не указан";
}

function portalStatusTone(athlete) {
  if (athlete.portal_activated) return s.profChildPortalOn;
  if (athlete.portal_login_email) return s.profChildPortalPending;
  return s.profChildPortalOff;
}

export default function ClientChildPortalAccess({ athlete, onUpdated }) {
  const toast = useToast();
  const [email, setEmail] = useState(athlete.portal_login_email || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setEmail(athlete.portal_login_email || "");
  }, [athlete.portal_login_email, athlete.id]);

  if (!athlete?.athlete_id && !athlete?.id) return null;
  const athleteId = athlete.athlete_id || athlete.id;

  const saveEmail = async () => {
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error("Укажите email");
      return;
    }
    setBusy(true);
    try {
      const r = await clinicAPI.updateFamilyAthleteLogin(athleteId, {
        email: trimmed,
      });
      toast.success("Email сохранён");
      onUpdated?.({
        ...athlete,
        portal_login_email: r.portal_login_email,
        portal_activated: r.portal_activated,
      });
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось сохранить");
    } finally {
      setBusy(false);
    }
  };

  const sendInvite = async () => {
    setBusy(true);
    try {
      const r = await clinicAPI.inviteFamilyAthletePortal(athleteId, {
        email: email.trim() || undefined,
      });
      await showPortalInviteFeedback(
        toast,
        {
          invite_url: r.invite_url,
          invite_email_sent: r.invite_email_sent,
          message: r.message,
        },
        r.message || "Приглашение отправлено",
      );
      onUpdated?.({
        ...athlete,
        portal_login_email: r.portal_login_email,
        portal_activated: r.portal_activated,
      });
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось отправить приглашение");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={s.profChildPortal}>
      <div className={s.profChildPortalHead}>
        <span className={s.profChildPortalTitle}>Личный кабинет ребёнка</span>
        <span className={`${s.profChildPortalStatus} ${portalStatusTone(athlete)}`}>
          {portalStatusLabel(athlete)}
        </span>
      </div>
      <p className={s.profChildPortalHint}>
        Ребёнок сможет входить со своего email и видеть расписание, абонемент и
        новости клуба. Вы по-прежнему управляете семьёй из своего аккаунта.
      </p>
      {athlete.portal_activated ? (
        <p className={s.profChildPortalActiveEmail}>
          Вход: <strong>{athlete.portal_login_email}</strong>
        </p>
      ) : (
        <>
          <Field
            label="Email ребёнка"
            hint="На этот адрес придёт ссылка для создания пароля"
          >
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="child@example.com"
              autoComplete="off"
            />
          </Field>
          <div className={s.profChildPortalActions}>
            <Button
              type="button"
              variant="secondary"
              size="sm"
              disabled={busy}
              onClick={saveEmail}
            >
              Сохранить email
            </Button>
            <Button type="button" size="sm" disabled={busy} onClick={sendInvite}>
              {busy ? "…" : "Отправить приглашение"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
